export default {
  "9142C": [
    {
      from_internal: "requestorPocLastName",
      to_c: "c1_poc_last",
      to_d: "d2_agent_last",
    },
    {
      from_internal: "requestorPocFirstName",
      to_c: "c2_poc_first",
      to_d: "d3_agent_first",
    },
    {
      from_internal: "requestorPocMiddleName",
      to_c: "c3_poc_middle",
      to_d: "d4_agent_middle",
    },
    {
      from_internal: "requestorPocJobTitle",
      to_c: "c4_poc_title",
      to_d: null,
    },
    {
      from_internal: "requestorPocAddr1",
      to_c: "c5_poc_address_1",
      to_d: "d5_agent_address_1",
    },
    {
      from_internal: "requestorPocAddr2",
      to_c: "c6_poc_address_2",
      to_d: "d6_agent_address_2",
    },
    {
      from_internal: "requestorPocCity",
      to_c: "c7_poc_city",
      to_d: "d7_agent_city",
    },
    {
      from_internal: "primaryWorksiteState",
      to_c: "c8_poc_state_id",
      to_d: "d8_agent_state_id",
      type: "state",
    },
    {
      from_internal: "requestorPocPostalCode",
      to_c: "c9_poc_zip",
      to_d: "d9_agent_zip",
    },
    {
      from_internal: "requestorPocCountry",
      to_c: "c10_poc_country_id",
      to_d: "d10_agent_country_id",
    },
    {
      from_internal: "requestorPocProvince",
      to_c: "c11_poc_province",
      to_d: "d11_agent_province",
    },
    {
      from_internal: "requestorPocPhone",
      to_c: "c12_poc_phone",
      to_d: "d12_agent_phone",
    },
    {
      from_internal: "requestorPocPhoneExt",
      to_c: "c13_poc_phone_ext",
      to_d: "d13_agent_phone_ext",
    },
    {
      from_internal: "requestorPocEmail",
      to_c: "c14_poc_email",
      to_d: "d14_agent_email",
    },
  ],

  "9142B": [
    {
      from_internal: "primaryWorksiteState",
      to_d: "jobState",
      to_e: null,
      type: "state",
    },
    {
      from_internal: "primaryWorksiteCounty",
      to_d: "jobCounty",
      to_e: null,
    },
    {
      from_internal: "requestorPocLastName",
      to_d: "emppocLastname",
      to_e: "attyLastname",
    },
    {
      from_internal: "requestorPocFirstName",
      to_d: "emppocFirstname",
      to_e: "attyFirstname",
    },
    {
      from_internal: "requestorPocMiddleName",
      to_d: "emppocMiddlename",
      to_e: "attyMiddlename",
    },
    {
      from_internal: "requestorPocJobTitle",
      to_d: "emppocJobtitle",
      to_e: null,
    },
    {
      from_internal: "requestorPocAddr1",
      to_d: "emppocAddr1",
      to_e: "attyAddr1",
    },
    {
      from_internal: "requestorPocAddr2",
      to_d: "emppocAddr2",
      to_e: "attyAddr2",
    },
    {
      from_internal: "requestorPocCity",
      to_d: "emppocCity",
      to_e: "attyCity",
    },
    {
      from_internal: "requestorPocState",
      to_d: "emppocState",
      to_e: "attyState",
      type: "state",
    },
    {
      from_internal: "requestorPocPostalCode",
      to_d: "emppocPostcode",
      to_e: "attyPostcode",
    },
    {
      from_internal: "requestorPocCountry",
      to_d: "emppocCountry",
      to_e: "attyCountry",
    },
    {
      from_internal: "requestorPocProvince",
      to_d: "emppocProvince",
      to_e: "attyProvince",
    },
    {
      from_internal: "requestorPocPhone",
      to_d: "emppocPhone",
      to_e: "attyPhone",
    },
    {
      from_internal: "requestorPocPhoneExt",
      to_d: "emppocPhoneext",
      to_e: "attyPhoneext",
    },
    {
      from_internal: "requestorPocEmail",
      to_d: "emppocEmail",
      to_e: "attyEmail",
    },
  ],
};
